import React from 'react';
import { useIntl } from 'react-intl';
import { Box, Typography, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import ProgressBar from '../../../Components/LinearProgress';
import { ColumnFlexBox } from '../../../Components/FlexBox';
import { formatThousands } from '../../../Utils/constants/general';

const SectionsCallsWidget = function SectionsCallsWidget({
  performedCustomerCalls = 0,
  plannedCalls = undefined,
  performedCalls = 0,
  performedOnTargetCalls = 0,
  target = 0,
  hideGap = false,
}) {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <ColumnFlexBox gap="8px">
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-end",
          gap: 3,
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}>
        {!hideGap && <div style={{ width: '60px', height: '60px' }} />}
        {plannedCalls !== undefined && (
          <div>
            <Typography
              sx={{
                color: theme.palette.greys.secondary,
              }}
              noWrap
              title={`${intl.messages.CUSTOMERS_CALLED}/${intl.messages.PLANNED_CUSTOMERS}`}
            >
              {`${intl.messages.CUSTOMERS_CALLED}/${intl.messages.PLANNED_CUSTOMERS}`}
            </Typography>
            <div>
              <Typography
                title={`${formatThousands(performedCustomerCalls)} / ${formatThousands(plannedCalls)}`}
                noWrap
                variant="h6"
                sx={{
                  fontSize: '2rem',
                  color: theme.palette.greys.secondary,
                }}
              >
                {formatThousands(performedCustomerCalls)}
                <span
                  style={{ fontSize: '1rem' }}
                >{` / ${formatThousands(plannedCalls)}`}</span>
              </Typography>
            </div>
          </div>
        )}
        <div>
          <Typography
            sx={{
              color: theme.palette.greys.secondary,
            }}
            noWrap
            title={intl.messages.OUTBOUND_CALLS_MADE}
          >
            {intl.messages.OUTBOUND_CALLS_MADE}
          </Typography>
          <div>
            <Typography
              title={
                performedCalls ? formatThousands(performedCalls) : undefined
              }
              noWrap
              variant="h6"
              sx={{
                fontSize: '2rem',
                color: theme.palette.greys.secondary,
              }}
            >
              {formatThousands(performedCalls)}
            </Typography>
          </div>
        </div>

        {target > 0 && (
          <div>
            <Typography
              sx={{
                color: theme.palette.greys.secondary,
              }}
              noWrap
              title={intl.messages.OUTBOUND_CALLS_MADE}
            >
              {`${intl.messages.ANSWERED_CALLS} / ${intl.messages.TARGET}`}
            </Typography>
            <div>
              <Typography
                noWrap
                variant="h6"
                sx={{
                  fontSize: '2rem',
                  color: theme.palette.greys.secondary,
                }}
              >
                {`${formatThousands(performedOnTargetCalls)} /
                  ${formatThousands(target)}`}
              </Typography>
            </div>
          </div>
        )}
      </Box>
      {target > 0 && (
        <ProgressBar
          value={performedOnTargetCalls}
          total={target}
          size="large"
          hideLabel
          showPercentageInside
        />
      )}
    </ColumnFlexBox>
  );
};

SectionsCallsWidget.propTypes = {
  performedCustomerCalls: PropTypes.number,
  plannedCalls: PropTypes.number,
  performedCalls: PropTypes.number,
};

export default SectionsCallsWidget;
